<template>
  <div id="app">
    <section class="el-container wrapper is-vertical">
      <el-container class="el-container">
        <el-header v-if="this.$route.path !== '/login'">
          <HeaderComponent></HeaderComponent>
        </el-header>
        <el-container class="page-container">
          <el-aside width="250px" class="menu" v-if="this.$route.path !== '/login'">
            <MainNavComponent ></MainNavComponent>
          </el-aside>
          <el-main>
            <transition name="fade">
              <router-view/>
            </transition>
          </el-main>
        </el-container>
      </el-container>      
    </section>
  </div>
</template>


<script>

  // Application View Componenets 
  import HeaderComponent from '@/components/Header'
  import MainNavComponent from '@/components/MainNav'
  import Interface from '@/store/Interface.js';


export default {
  name: 'App',

    data: function() {
    return{
        nav_collapsed: Interface.state.nav_collapsed,
      };
    },

  components: {
    HeaderComponent,
    MainNavComponent
  },


}
</script>

<style>

pre {
  display: none;
}

body, html {
  margin:0 !important;
  padding:0 !important;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size:14px;
  height: 100%;
}

 

  .bottom-spacer {
    margin-bottom: 30px;
  }

.wrapper {
  height:100%;
}



.menu {
  height:100%;
}


.el-header {
  padding:0 !important;
}

.pagination {
  padding: 30px 0 30px 0;
}

.actions-bar {
  background-color: #F2F6FC;
  padding: 20px;
  margin: 10px 0 30px 0;
  border: 1px solid #EBEEF5;
}

.crumbs-bar {
  margin: 10px 0 30px 0;  
}
  
.text-right {
  text-align: right;
}  

.title-text {
  font-size:16px;
  font-weight: 900;
}

/*Transitions*/
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0
}

.main-container, .main-nav,  {
  height: 100%;
}

hr {
  height: 1px;
  background: #E4E7ED;
  border: 0;
}

.breather {
  margin: 10px 0 25px 0;
}

.card-header-spacer {
  line-height: 40px;
  height: 40px;
}

.card-title {
  font-size: 14px;
  font-weight: 700;
}

.img-responsive {
  width:100%;
  height: 100%;
}

.row-spacer {
  margin-bottom: 30px;
}

.scroll-pane {
  height: 400px;
  overflow-y: scroll;
  padding: 20px;
}

.form-hint {
  display: block;
  color: #606266;
  font-size: 13px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue